import React, {useState, useEffect, useMemo} from "react";
import { useApp } from "../../contexts";
import { useNavigate } from "react-router-dom";
import { getPropByLanguage } from "../../utils/Language";
import {
  baseCurrencyCode,
  validateDecimalSeparator,
  prefixCcySymbol,
  suffixCcySymbol,
  thousandSeparatorByCurrency,
  decimalSeparatorByCurrency,
} from "../../utils/Currency";
import IconMotion from "../../components/Icons/IconMotion"
import IconPicture from "../../components/Icons/IconPicture"
import NumberFormat from "react-number-format";
import {
  roundNumber,
} from "../../services/app";

export const ItemEarner = ({ value, ...props }) => {
  const {
    T,
    language,
    convertToLocalCurrency,
    formatLocalCurrency,
    getCurrency,
  } = useApp();
  const navigate = useNavigate();
  const { title, categories, itemData } = props;

  const [breedTranslate, setBreedTranslate] = useState(itemData?.breed);
  const [rank, setRank] = useState("");
  useEffect(() => {
    if (categories && categories.length) {
      const category = categories.find(item => item.id == itemData?.nft_type_category_id)
      if (category) {
        setBreedTranslate(category.nameTranslate[getPropByLanguage(language)] || category.nameTranslate['english'])
        const dogLevels = category?.dogLevel;
        if (dogLevels?.length > 0) {
          const dogLevelsSelected = dogLevels?.find((lvl) => lvl.rankCode == itemData?.rank_code)
          setRank(dogLevelsSelected?.rankTranslate[getPropByLanguage(language)] || Number(itemData?.level));
        }
      }else{
        setBreedTranslate(itemData?.breed)
      }
    }
  }, [categories, language, itemData]);
  const handleClickDetail = () => {
    navigate(`/earner-detail/${itemData?.id}`);
    // if (!!itemData?.token_id_onchain) {
    //   window.open(
    //     `${itemData?.nft_page_base_url}`
    //   );
    // } else {
    //   navigate(`/earner-detail/${itemData?.id}`);
    // }
  };

  return (
    <div className={`w-full item-earner-guild`}>
      <div className="item-image relative">
        <img
          src={
            itemData?.img
          }
          alt={itemData?.name}
          className="!object-cover"
          loading="lazy"
        />
        <div className="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
        {itemData?.tag_nft_type == 'photo' ? <div className="item-tag item-picture">
            <IconPicture /><span>{T('Photo')}</span>
        </div>: <></>}
        {itemData?.tag_nft_type == 'motion' ? <div className="item-tag item-motion">
            <IconMotion /> <span>{T('Motion')}</span>
        </div>: <></>}
      </div>
      <div className="item-content">
        <div className="item-title">{T(title)}</div>
        <div className="item-des">{breedTranslate} #{itemData?.id}</div>
        <div className="item-propertys">
          {!!itemData?.token_id_onchain ? <div className="item-property">
            <div className="item-label">{T("Token ID")}</div>
            <div className="item-value">{itemData?.token_id_onchain}</div>
          </div>: <div className="item-property">
            <div className="item-label">{T("Rank")}</div>
            <div className="item-value">{rank}</div>
          </div> }
          
          <div className="item-property">
            <div className="item-label">{T("Principal")}</div>
            <div className="item-value">
              {itemData?.principal_amount_sgt > 0 && <NumberFormat
                value={Number(itemData?.principal_amount_sgt)}
                displayType={"text"}
                thousandSeparator={thousandSeparatorByCurrency(getCurrency())}
                decimalSeparator={decimalSeparatorByCurrency(getCurrency())}
                suffix={' SGT'}
                decimalScale={8}
              />}</div>
          </div>
        </div>
        <div className="flex justify-start">
          <button className="explore-earner-btn" onClick={handleClickDetail}>
            {T("Details")}
          </button>
        </div>
      </div>
    </div>
  );
};
